import { useEffect } from 'react'
import { Icon } from '@iconify/react'
import './AnalysisResultModal.css'

const AnalysisResultModal = ({ isOpen, onClose, isLoading, results }) => {
  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && !isLoading) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, isLoading, onClose])

  if (!isOpen) return null

  return (
    <div className="analysis-modal-overlay" onClick={!isLoading ? onClose : undefined}>
      <div className="analysis-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="analysis-modal-header">
          <h2 className="analysis-modal-title">계약서 분석 결과</h2>
          {!isLoading && (
            <button className="analysis-modal-close" onClick={onClose}>
              <Icon icon="solar:close-circle-bold" width={20} height={20} />
            </button>
          )}
        </div>

        <div className="analysis-modal-content">
          {isLoading ? (
            <div className="analysis-loading">
              <Icon icon="solar:refresh-bold" className="analysis-spinner" width={48} height={48} style={{ animation: 'spin 1s linear infinite' }} />
              <p className="analysis-loading-text">계약서를 분석하고 있습니다...</p>
              <p className="analysis-loading-subtext">잠시만 기다려주세요</p>
            </div>
          ) : results && results.length > 0 ? (
            <div className="analysis-results">
              <div className="analysis-results-header">
                <Icon icon="solar:danger-triangle-bold" className="analysis-warning-icon" width={24} height={24} />
                <h3 className="analysis-results-title">발견된 독소 조항</h3>
              </div>
              <div className="analysis-results-list">
                {results.map((item, index) => (
                  <div key={index} className="analysis-result-item">
                    <div className="analysis-result-number">{index + 1}</div>
                    <div className="analysis-result-content">
                      <h4 className="analysis-result-title">{item.title}</h4>
                      <div className="analysis-result-summary">
                        {item.summary.map((line, lineIndex) => (
                          <p key={lineIndex} className="analysis-result-line">
                            {line}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="analysis-no-results">
              <p>독소 조항이 발견되지 않았습니다.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AnalysisResultModal

